import { useTranslation } from "react-i18next";
import { contactInfo } from "@/mocks/home";

export default function TopBar() {
  const { t } = useTranslation("home");

  return (
    <div className="bg-magenta text-white w-full">
      <div className="w-full px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between py-2 text-sm">
        <span className="whitespace-nowrap">{t("topBar.welcome")}</span>
        <div className="flex items-center gap-4 md:gap-6 mt-1 sm:mt-0">
          <a
            href={contactInfo.phoneHref}
            className="hover:text-white/80 transition-colors whitespace-nowrap"
            rel="nofollow"
          >
            {contactInfo.phone}
          </a>
          <a
            href={contactInfo.emailHref}
            className="hover:text-white/80 transition-colors whitespace-nowrap hidden sm:inline"
            rel="nofollow"
          >
            {contactInfo.email}
          </a>
        </div>
      </div>
    </div>
  );
}